// extracted by mini-css-extract-plugin
export default {"wrapper":"SkeletonProfileEditInfo_wrapper__mv33D","content":"SkeletonProfileEditInfo_content__33pZS"};